<div id="SlipControlModal"
     class="ui modal">

  <div class="content">
    <span style="font-weight:bold;font-size:18px">{{"Coupons_Didnt_Found" | t}}
      !!!</span>
    <button class="circular ui icon button"
            style="float:right;position:relative;bottom:10px;background-color:white;border: 1px solid;"
            (click)="SlipControlModal_Button_No()">
      <i class="remove link icon"></i>
    </button>
  </div>

</div>
<div id="CardCustomerId"
     class="ui modal">
  <div class="content">
        <span style="font-weight:bold">
            CustomerId:<span>{{this.tournamentsService.cardCustomerId}}</span>
        </span>
    <button class="circular ui icon button"
            style="float:right;position:relative;bottom:10px;background-color:white;border: 1px solid;"
            (click)="CardCustomerId_Button_No()">
      <i class="remove link icon"></i>
    </button>
  </div>
</div>

<!--<div class="ui grid segment" style="height:90%">-->


<router-outlet>


</router-outlet>


<!--</div>-->


<comp_languagemodal (selectedLanguage_LangCode)="Change_SelectedLanguage_LangCode($event)"></comp_languagemodal>

<comp_infomodal></comp_infomodal>
<comp_payout_limit_modal></comp_payout_limit_modal>
<comp_customer_card_message_modal></comp_customer_card_message_modal>
<comp_payout_modal></comp_payout_modal>
<comp_message_modal></comp_message_modal>
<comp_live_cashout_modal></comp_live_cashout_modal>

<comp_print_credit_voucher></comp_print_credit_voucher>


<comp_results_modal></comp_results_modal>
<comp_settingsPassword_modal></comp_settingsPassword_modal>

<comp_livetracker_modal></comp_livetracker_modal>


<adminMenu *ngIf="this._uiHelper.isAdminScreenVisible"></adminMenu>

<iframe hidden
        style="width:274px"
        id="Ticket_Credit_Voucher_PrintArea_Iframe"
        name="Ticket_Credit_Voucher_PrintArea_Iframe"></iframe>

<iframe hidden
        style="width:274px"
        id="Ticket_LastSlip_Detail_PrintArea_Iframe"
        name="Ticket_LastSlip_Detail_PrintArea_Iframe"></iframe>

<iframe hidden
        style="width:274px"
        id="Ticket_CloseCashbox_PrintArea_Iframe"
        name="Ticket_CloseCashbox_PrintArea_Iframe"></iframe>
<iframe hidden
        style="width:274px"
        id="Ticket_CheckCashbox_PrintArea_Iframe"
        name="Ticket_CheckCashbox_PrintArea_Iframe"></iframe>

<div style="padding: 8px;background-color: orange">
  <comp_standings_modal></comp_standings_modal>

</div>

<comp_qr_modal></comp_qr_modal>
<comp_transactions_modal></comp_transactions_modal>
<comp-slip-duplicate-modal></comp-slip-duplicate-modal>
<comp_barcode_card_modal></comp_barcode_card_modal>
<app-qr-reward></app-qr-reward>

<div id="cashoutWaitingModal" class="ui modal cashoutWaitingModal">
  <div class="loaderContainer">
    <div class="loader"></div>
  </div>
  <div class="loaderTextContainer">
    <div class="loaderText">
      <span>
        {{ "CashoutWait" | t}}
      </span>
    </div>
  </div>
</div>



<script>
  var dt = new Date();
  document.getElementById("datetime").innerHTML = dt.toLocaleString();
</script>
